define('bindingHandlers/util/spinnerUtil',[
    'lib/knockout',
    'moment',
    'lib/lodash4'
], function (
    ko,
    moment,
    _
    ) {
    "use strict";


    /**
     *  SPINNER UTILITY
     *
     *  @description used to assist number pickers in checking max values, setting up click events, and providing values for templates
     */


    var spinnerControl = {};

    var handleClickDirections = function(units, step, clearValue, shouldRound) {
        //dynamically sets click up and down
        _.each(units, function(unit, key) {
            var unitStep = _.has(step, key) ? step[key] : 1;
            var unitStepShouldRound = shouldRound && shouldRound[key];

            spinnerControl["click_" + key + "_up"] = function(){
                clickUp(unit, unitStep, unitStepShouldRound);
            };
            spinnerControl["click_" + key + "_down"] = function(){
                clickDown(unit, unitStep, unitStepShouldRound);
            };
        });

        //clears the request units
        spinnerControl.click_clear = function() {
            _.each(units, function(property, key){
                var valueOnClear = _.has(clearValue, key) ? clearValue[key] : 0;
                property(valueOnClear);
            });
        };

        var clickUp = function(obs, stepUp, shouldRound) {
            var val = shouldRound ? roundDownToMultiple(obs(), stepUp) : obs();
            obs(val + stepUp);
        };

        var clickDown = function(obs, stepDown, shouldRound) {
            var val = shouldRound ? roundUpToMultiple(obs(), stepDown) : obs();
            obs(val - stepDown);
        };

        function roundUpToMultiple(val, multiple) {
            return Math.ceil(val / multiple) * multiple;
        }

        function roundDownToMultiple(val, multiple) {
            return Math.floor(val / multiple) * multiple;
        }

        return spinnerControl;
    };

    return {
        handleClickDirections: handleClickDirections
    };
});

